import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllLoans } from "../../redux/slices/loan/loanReportSlice";
import { fetchCustomers } from "../../redux/slices/Customer/customerReportSlice";
import { fetchUserProfile } from "../../redux/slices/branch/userProfileSlice";
import { toast } from "react-toastify";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import "./Sanction.css";

const LoanSanctionLetter = () => {
  const { loanId } = useParams();
  const dispatch = useDispatch();

  const { loans } = useSelector((state) => state.loanReport);
  const { customers } = useSelector((state) => state.customerReport);
  const { profile } = useSelector((state) => state.userProfile);

  const [loan, setLoan] = useState(null);
  const [guarantor, setGuarantor] = useState(null);
  const [customer, setCustomer] = useState(null);
  const [company, setCompany] = useState(null);
  const [photoUrl, setPhotoUrl] = useState(null);

  const [signatureUrl, setSignatureUrl] = useState(null);

  const createdById = Number(localStorage.getItem("userId")) || 0;

  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);

  useEffect(() => {
    const branchId = Number(localStorage.getItem("userId")) || 0;

    const loadData = async () => {
      try {
        // ✅ Fetch loan
        const loanAction = await dispatch(fetchAllLoans());
        const loanList = loanAction.payload?.data || loanAction.payload || [];
        const selectedLoan = loanList.find(
          (l) => String(l.id) === String(loanId),
        );
        if (!selectedLoan) {
          toast.error("Loan not found");
          return;
        }
        setLoan(selectedLoan);

        // ✅ Fetch customer
        const customerAction = await dispatch(
          fetchCustomers({
            page: 1,
            limit: 1000,
            superAdminId: profile.superAdminId,
          }),
        );
        const customerList =
          customerAction.payload?.data || customerAction.payload || [];
        const selectedCustomer = customerList.find(
          (c) =>
            String(c.userId).toLowerCase() ===
            String(selectedLoan.customerId).toLowerCase(),
        );
        setCustomer(selectedCustomer);

        // ✅ Fetch company info
        if (profile?.superAdminId) {
          const res = await fetch(
            `https://payyug.in/api/get-company?superAdminId=${profile.superAdminId}`,
          );
          const data = await res.json();
          if (res.ok) {
            const companyInfo = data.data || data;
            if (companyInfo.logo) {
              companyInfo.logoUrl = `https://payyug.in/${companyInfo.logo.replace(/^images\//, "")}`;
            }
            setCompany(companyInfo);
          }
        }

        // ✅ Fetch customer photo
        if (selectedCustomer?.userId && profile?.superAdminId) {
          try {
            const res = await fetch(
              `https://payyug.in/api/list-kyc?userId=${selectedCustomer.userId}&superAdminId=${profile.superAdminId}&createdId=${profile.id}`,
            );
            const data = await res.json();
            console.log("KYC Data:", data);
            if (res.ok && data.documents?.length > 0) {
              const photoDoc = data.documents.find(
                (doc) => doc.docName?.toLowerCase() === "photo",
              );
              const signDoc = data.documents.find(
                (doc) => doc.docName?.toLowerCase() === "signature",
              );
              if (photoDoc?.docImage)
                setPhotoUrl(`https://payyug.in/uploads/${photoDoc.docImage}`);

              if (signDoc?.docImage)
                setSignatureUrl(
                  `https://payyug.in/uploads/${signDoc.docImage}`,
                );
              console.log(
                "signatureUrl:",
                `https://payyug.in/uploads/${signDoc.docImage}`,
              );
            }
          } catch (err) {
            console.error("Failed to fetch customer KYC:", err);
          }
        }

        // ✅ Fetch guarantor/nominee
        if (selectedLoan.customerId) {
          const url = `https://payyug.in/api/nominee-get-all?loanId=${loanId}&branchId=${branchId || 0}&customerId=${selectedLoan.customerId}`;
          const res = await fetch(url);
          const data = await res.json();
          if (
            res.ok &&
            data.success &&
            Array.isArray(data.data) &&
            data.data.length > 0
          ) {
            setGuarantor(data.data[0]);
          }
        }
      } catch (err) {
        console.error(err);
        // toast.error(err?.response?.data?.message || "Error loading data");
      }
    };

    loadData();
  }, [dispatch, loanId, profile, createdById]);

  // === PDF Download Function ===
  const handleDownloadPDF = async () => {
    const button = document.querySelector(".loan-application-print-button");
    if (button) button.style.display = "none";

    const input = document.querySelector(".Sanc-letter-container");
    if (!input) return;

    const canvas = await html2canvas(input, {
      scale: 2,
      useCORS: true,
      logging: false,
    });
    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF("p", "mm", "a4");
    const imgWidth = 210;
    const pageHeight = 297;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;
    let heightLeft = imgHeight;
    let position = 0;

    pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
    while (heightLeft > 0) {
      heightLeft -= pageHeight;
      if (heightLeft > 0) {
        pdf.addPage();
        pdf.addImage(imgData, "PNG", 0, -heightLeft, imgWidth, imgHeight);
      }
    }

    pdf.save(`LoanSanctionLetter_${loanId}.pdf`);
    if (button) button.style.display = "block";
  };

  if (!loan) return <p>Loading...</p>;

  const c = customer || {};
  const companyName = company?.name || "Techvision Company";
  const companyLogo = company?.logoUrl || "/logo.png";
  const companyCIN = company?.cin || "U88900AS2025NPL028600";
  const companyMobile = company?.contact || "0000000000";
  const companyEmail = company?.email || "xyz@gmail.com";
  const companyAddress =
    company?.address || "House No-4, Ahiyapur, Muzaffarpur, Bihar - 781014";
  const appliedDate = loan.loanAppliedDate
    ? new Date(loan.loanAppliedDate).toLocaleDateString("en-GB")
    : "-";

  // console.log("customer",c)
  // console.log("customerAction:", customerAction);
  // console.log("payload:", customerAction.payload);

  return (
    <div className="Sanc-letter-container">
      {/* Header */}
      <div className="Sancletter-header">
        <div className="Sanclogo-box">
          <img src={companyLogo} alt="logo" crossOrigin="anonymous" />
        </div>
        <div className="Sanccompany-details">
          <h2>
            {companyName ||
              "hello this is the name of our country and the branch of city"}
          </h2>
          <span>
            <strong>CIN:</strong> {companyCIN}
          </span>
          <span>
            <strong>Regt. Office:</strong> {companyAddress}
          </span>
          {/* <span><strong>Regt. Office:</strong> gfgjhjkgjhkjhskjgkj  hjkhskjisjkhfo  hkjhjkhkjgshkjhk hjkhkjhskjhfkjhsoi </span> */}
          <span>
            <strong>Mobile:</strong> {companyMobile}
          </span>
          <span>
            <strong>Email:</strong> {companyEmail}
          </span>
        </div>
      </div>

      <h3 className="Sanctitle">Loan Sanction Letter</h3>

      {/* Loan Basic Info */}
      <table className="Sancdetails-table">
        <tbody>
          <tr>
            <td>
              <strong>Branch Name:</strong> {profile?.branchName || "N/A"}
            </td>
            <td>
              <strong>Applied Date:</strong> {appliedDate}
            </td>
            {/* <td><strong>Loan ID:</strong> {loan.loanNumber || loan.id}</td> */}
            {/* <td><strong>Loan Type:</strong> {loan.loanService || "-"}</td> */}
          </tr>
        </tbody>
      </table>

      {/* Customer Info */}
      <table className="Sancdetails-table">
        <tbody>
          <tr>
            <td className="field-name">Customer Name</td>
            <td className="field-value">{c.fullName || "-"}</td>
            <td className="field-name">C/O</td>
            <td className="field-value">{c.guardianName || "-"}</td>
            <td rowSpan="4" className="Sancphoto-box">
              <img
                src={photoUrl || "/user.png"}
                alt="customer"
                crossOrigin="anonymous"
              />
            </td>
          </tr>
          <tr>
            <td className="field-name">District</td>
            <td className="field-value">{c.district || "-"} </td>
            <td className="field-name">Contact Number</td>
            <td className="field-value">{c.mobileNumber || "-"}</td>
          </tr>
          <tr>
            <td className="field-name">Gender</td>
            <td className="field-value">{c.gender || "-"}</td>
            <td className="field-name">Date of Birth</td>
            <td className="field-value">
              {c.dateOfBirth
                ? new Date(c.dateOfBirth).toLocaleDateString("en-GB")
                : "-"}
            </td>
          </tr>
          <tr className="full-address-row">
            <td className="field-name">Full Address</td>
            <td className="field-value" colSpan="4">
              {[
                c.address,
                // c.state,
                c.country,
                c.pincode,
              ]
                .filter(Boolean)
                .join(", ") || "-"}
            </td>
          </tr>
        </tbody>
      </table>

      {/* Bank / Loan Details */}
      <h4 className="Sanc-details-heading">Loan Details</h4>
      <table className="Sanc-Bank-table">
        <tbody>
          <tr>
            <td className="field-name">Loan Account Number</td>
            <td className="field-value">{loan.loanAccountNumber || "-"}</td>
            <td className="field-name">Loan Amount</td>
            <td className="field-value">{loan.loanAmount || "-"}</td>
          </tr>
          {/* <tr>
            <td className="field-name">Bank</td>
            <td className="field-value">{c.bankName || "-"}</td>
            <td className="field-name">Bank Branch</td>
            <td className="field-value">{c.bankBranch || "-"}</td>
          </tr> */}
          <tr>
            <td className="field-name">Plan Name</td>
            <td className="field-value">{loan.loanService || "-"}</td>
            <td className="field-name">Purpose</td>
            <td className="field-value">{loan.loanPurpose || "-"}</td>
          </tr>
          <tr>
            <td className="field-name">Recovery Ferequency</td>
            <td className="field-value">{loan.loanRecoveryFrequency || "-"}</td>
            <td className="field-name">Interest Type</td>
            <td className="field-value">{loan.loanRoiType || "-"}</td>
          </tr>
          {/* <tr>
            <td className="field-name">Account Holder</td>
            <td className="field-value">{c.fullName || "-"}</td>
            <td className="field-name">Loan Account Number</td>
            <td className="field-value">{loan.loanAccountNumber || "-"}</td>
          </tr> */}
          <tr>
            <td className="field-name">Total Emi</td>
            <td className="field-value">{loan.loanTenure || "-"}</td>
            {/* <td className="field-name">IFSC</td>
            <td className="field-value">{c.bankIFSC || "-"}</td> */}
            <td className="field-name">Amount to be Paid</td>
            <td className="field-value">{loan.loanPayable || "-"}</td>
          </tr>
          <tr>
            <td className="field-name">Interest Rate (%)</td>
            <td className="field-value">{loan.loanRoi || "-"}</td>
            <td className="field-name">Emi Amount</td>
            <td className="field-value">{loan.loanEmiAmount || "-"}</td>
            {/* <td className="field-name">EMI Amount</td>
            <td className="field-value">{loan.emiAmount || "-"}</td> */}
          </tr>
          <tr></tr>
        </tbody>
      </table>

      {/* Guarantor Info */}
      <h4 className="Sanc-details-heading">Guarantor Details</h4>
      <table className="Sanc-Guarantor-tables">
        <tbody>
          <tr>
            <td className="field-name">Guarantor Name</td>
            <td className="field-value">{guarantor?.guarantorName || "-"}</td>
            <td className="field-name">Aadhaar No</td>
            <td className="field-value">{guarantor?.guarantorAadhar || "-"}</td>
            <td rowSpan="3" className="Sanc-Guarantor-photo-box">
              <img
                src={
                  guarantor?.guarantorImage
                    ? `https://payyug.in/uploads/${guarantor.guarantorImage}`
                    : "/user.png"
                }
                alt="guarantor"
                crossOrigin="anonymous"
              />
            </td>
          </tr>
          <tr>
            <td className="field-name">Contact Number</td>
            <td className="field-value">{guarantor?.guarantorMobile || "-"}</td>
            <td className="field-name">PAN No</td>
            <td className="field-value">{guarantor?.panNumber || "-"}</td>
          </tr>
          <tr>
            <td className="field-name">Relation</td>
            <td className="field-value">
              {guarantor?.relationApplicant || "-"}
            </td>
          </tr>
        </tbody>
      </table>

      {/* Signature Section */}
      <table className="Sanc-Signature-table">
        <tbody>
          <tr>
            <td>
              Member Signature <br /> (सदस्य के हस्ताक्षर)
              <div style={{ height: "80px" }}>
                {signatureUrl && signatureUrl.trim() !== "" ? (
                  <img
                    src={signatureUrl}
                    alt="Member Signature"
                    className="Sanc-Signature-img"
                    style={{
                      width: "150px",
                      height: "50px",
                      marginTop: "14px",
                      marginLeft: "2rem",
                    }}
                  />
                ) : (
                  <p className="sanc-no-signature-text">No Signature Upload</p>
                )}
              </div>
            </td>
            <td>
              Spouse Signature <br /> (जीवनसाथी के हस्ताक्षर)
              <div></div>
            </td>
            <td>
              Branch Seal With Signature <br /> (शाखा मोहर के साथ हस्ताक्षर)
              <div></div>
            </td>
          </tr>
        </tbody>
      </table>

      <div className="loan-application-print-button">
        <button onClick={handleDownloadPDF}>Download PDF</button>
      </div>
    </div>
  );
};

export default LoanSanctionLetter;
